import { render, staticRenderFns } from "./noTeacherInfo.vue?vue&type=template&id=275d29ca&scoped=true&"
import script from "./noTeacherInfo.vue?vue&type=script&lang=js&"
export * from "./noTeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./noTeacherInfo.vue?vue&type=style&index=0&id=275d29ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d29ca",
  null
  
)

export default component.exports